import React from "react"
import { RellaxWrapper as Rellax } from "react-rellax-wrapper"
import { getSrc } from "gatsby-plugin-image"
import { Cta } from "@components/common/cta/Cta"

import * as s from "./SnapshotBillboard.module.scss"

export const SnapshotBillboard = ({ data }) => {
  return (
    <div className={`${s.snapshotBillboard}`}>
      <div
        className={`${s.snapshotBillboard__inner} ${
          data.direction === "LTR" ? s.snapshotBillboard__inner___LTR : ""
        }`}
      >
        <div
          className={`${s.snapshotBillboard__panel} ${
            data.direction === "LTR" ? s.snapshotBillboard__panelLTR : ""
          } `}
        >
          {data.icon && (
            <div className={s.snapshotBillboard__panel___icon}>
              <img src={data.icon.sourceUrl} alt={data.icon.altText} />
            </div>
          )}
          <h3 className={s.snapshotBillboard__panel___heading}>{data.title}</h3>
          <p className={s.snapshotBillboard__panel___blurb}>{data.blurb}</p>
          {data.links &&
            data.links.map((link, i) => {
              const linkData = link.link;
              if (!linkData || !linkData.url || !linkData.title) return null;

              return (
                <Cta
                  key={i}
                  className={s.snapshotBillboard__panel___link}
                  link={linkData.url}
                  title={linkData.title}
                />
              );
          })}
        </div>
        <div className={`${s.snapshotBillboard__photoContainer} `}>
          {data.images.map((image, i) => {
            const enumeratedClassName = i => {
              if (data.direction === "RTL") {
                if (i === 0) {
                  return s.snapshotBillboard__photographRTL0
                }
                if (i === 1) {
                  return s.snapshotBillboard__photographRTL1
                }
                if (i === 2) {
                  return s.snapshotBillboard__photographRTL2
                }
              }
              if (data.direction === "LTR") {
                if (i === 0) {
                  return s.snapshotBillboard__photographLTR0
                }
                if (i === 1) {
                  return s.snapshotBillboard__photographLTR1
                }
                if (i === 2) {
                  return s.snapshotBillboard__photographLTR2
                }
              } else return ""
            }
            return (
              <Rellax
                key={i}
                center={true}
                xs={0.5 * i}
                mobile={0.5 * i}
                tablet={1 * i}
                desktop={1 * i}
                className={enumeratedClassName(i)}
                percentage={0.7}
              >
                <div
                  role="image"
                  aria-label={image.image?.altText}
                  className={`${s.snapshotBillboard__photograph} `}
                  style={{
                    backgroundImage: `url(${image.image.localFile ? getSrc(image.image.localFile) : image.image.sourceUrl})`,
                  }}
                ></div>
              </Rellax>
            )
          })}
        </div>
      </div>
    </div>
  )
}
